import API from './index';
import methods from '../constants/methods';

const getPublicConfiguration = () => {
    const requestOptions = {
        path: '/api/ui/configuration',
        isProxy: true,
        timeout: 30000,
    };

    const headerOptions = {
        method: methods.GET.method,
    };

    return API.initiateSessionApiCall(requestOptions, headerOptions);
};

export default {
    getPublicConfiguration,
};
